<template>
  <div class="main-content">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <h5>Список карт <button v-if="!showDisabled" @click="showDisabled = !showDisabled" class="btn btn-info pull-right">Показать архивные</button></h5>
          </div>
          <div class="card-body">
            <div class="alert alert-info">Таблица с возможностью редактировать порядок активации карт. Кликните на строке и удерживайте кнопку для смены порядка карт.</div>
            <table class="table table-hover">
              <thead>
              <tr>
                <th></th>
                <th>ID</th>
                <th></th>
                <th>Номер</th>
                <th>Имя</th>
                <th>Действие (дней)</th>
                <th></th>
                <th>Активность</th>
                <th></th>
              </tr>
              </thead>
              <draggable v-model="records" v-if="records && records.length" tag="tbody">
                <tr v-for="(record, index) in records" :key="record.id">
                  <td>{{ index + 1 }} <i class="icon-fa icon-fa-arrows pointer"></i></td>
                  <td>{{record.id}}</td>
                  <td>{{printCardType(record.type)}}</td>
                  <td>{{printNumber(record.number)}}</td>
                  <td>{{record.owner.short_name}}</td>
                  <td>{{record.period}}
                    <vue-ladda @click="activateCard(record.id)" button-class="ml-1 btn-success btn-xs" v-if="!record.in_use"
                               data-style="zoom-in"
                               :loading="loadingBtns[record.id]">Активировать
                    </vue-ladda>
                  </td>
                  <td><span v-if="record.is_active" :class="`${record.in_use ? 'badge-success' : 'badge-info'} badge text-left`" v-html="printUsage(record)"></span></td>
                  <td><span class="badge badge-success" v-if="record.is_active">Активна</span><span
                    class="badge badge-warning" v-else>Не активна</span></td>
                  <!--                                <td>{{record.order_use}}</td>-->
                  <td><a href="#" @click="mixinGoToRouter('settingsCardsNewEdit',{id:record.id})"
                         class="btn btn-sm btn-info">Редактировать</a></td>
                </tr>
              </draggable>
            </table>

<!--            <div class="text-right">-->
<!--              <paginate v-if="paginator"-->
<!--                        :page-count="paginator.last_page"-->
<!--                        :page-range="3"-->
<!--                        :margin-pages="2"-->
<!--                        :click-handler="getData"-->
<!--                        :prev-text="'&laquo'"-->
<!--                        :next-text="'&raquo'"-->
<!--                        :container-class="'pagination'"-->
<!--                        :prev-class="'page-item'"-->
<!--                        :prev-link-class="'page-link'"-->
<!--                        :page-class="'page-item'"-->
<!--                        :page-link-class="'page-link'"-->
<!--                        :next-class="'page-item'"-->
<!--                        :next-link-class="'page-link'"-->
<!--                        :active-class="'active green_btn'">-->
<!--              </paginate>-->
<!--            </div>-->

            <div class="text-right">
              <vue-ladda @click="saveCardOrder" button-class="btn-success btn"
                         data-style="zoom-in"
                         :loading="saveLoading">Сохранить порядок
              </vue-ladda>
            </div>

          </div>
        </div>

        <div class="card" v-if="showDisabled">
          <div class="card-header">
            <h5>Не активные карты</h5>
          </div>
          <div class="card-body">
            <div v-if="noActive && noActive.length">
              <table class="table">
                <thead>
                  <tr>
                    <th></th>
                    <th>ID</th>
                    <th></th>
                    <th>Номер</th>
                    <th>Имя</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(record, index) in noActive">
                    <td>{{index+1}}</td>
                    <td>{{record.id}}</td>
                    <td>{{printCardType(record.type)}}</td>
                    <td>{{printNumber(record.number)}}</td>
                    <td>{{record.owner.short_name}}</td>
                    <td>
                      <vue-ladda @click="activateCard(record.id, true)" button-class="ml-1 btn-success btn-xs"
                                 data-style="zoom-in"
                                 :loading="loadingBtns[record.id]">Сделать активной
                      </vue-ladda>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div v-else class="alert alert-info">
              Не активных карт не найдено
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<style scoped>
  .pagination {
    justify-content: flex-end;
  }

  table.table td {
    padding: 3px;
  }

  .badge {
    color: white;
    font-size: 13px;
    font-weight: 400;
  }
</style>

<script>
  import api from '@/api'
  // import Paginate from 'vuejs-paginate'
  import VueLadda from 'vue-ladda/src/vue-ladda.vue'
  import draggable from 'vuedraggable'

  export default {
    components: {
      // Paginate,
      VueLadda,
      draggable,
    },
    data() {
      return {
        showDisabled: false,
        saveLoading: false,
        loadingBtns: {},
        records: null,
        noActive: null,
        paginator: null
      }
    },
    mounted() {
      this.getData()
    },
    methods: {
      async saveCardOrder() {
        const {data} = await api.post('/cards/updateOrderUse',{
          cardsOrder: this.records.map((c) => c.id)
        });
        if (data.success){
          toastr['success']('Обновлено');
        }else{
          toastr['warning'](data.message || 'Ошибка');
        }
      },
      async activateCard(cardId, activity = false) {
        this.loadingBtns[cardId] = true;
        const {data} = await api.index('/cards/activateCard/' + cardId +'?activity='+activity);
        if (data.success){
          toastr['success']('Обновлено');
          await this.getData();
        }else{
          toastr['warning'](data.message || 'Ошибка');
        }
        this.loadingBtns[cardId] = false;
      },
      printCardType(type) {
        return type == 1 ? 'VISA' : 'MASTER'
      },
      printUsage(card) {
        let html = '';
        if (!card.in_use) {
          if (!card.end_use) return;

          const start = new Date(card.start_use);
          const end = new Date(card.end_use);
          const diffTime = Math.abs(end - start);
          const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

          html += 'Была в использовании (<b>' + diffDays + '</b>)<br>До: ' + card.end_use;
        } else {

          const end = new Date(card.start_use);
          end.setDate(end.getDate() + card.period);
          const today = new Date();
          const diffTime = Math.abs(end - today);
          const diffDays = Math.round(diffTime / (1000 * 60 * 60 * 24));

          html += 'В использовании (<b>' + card.period + '</b>) с';
          html += '<br>' + card.start_use + '<br>Будет действовать еще :<B>' + diffDays + "</B> день(ей)";
        }
        return html;
      },
      printNumber(num) {
        return num.substr(0, 4) + ' ' + num.substr(4, 4) + ' ' + num.substr(8, 4) + ' ' + num.substr(12);
      },
      async getData(page = null) {
        // let {data: r_data} = await api.index('/settings/getCards?page=' + page)
        // const {data, ...pagination} = r_data.cards
        // this.loadingBtns = data.reduce((acc, r) => ({ ...acc, [r.id]: false}), {})
        // this.paginator = pagination
        // this.records = data
        let {data} = await api.index('/cards/getCards');
        this.loadingBtns = data.cards.reduce((acc, r) => ({ ...acc, [r.id]: false}), {})
        this.records = data.cards.filter((c) => c.is_active);
        this.noActive = data.cards.filter((c) => !c.is_active);

      },
    }
  }
</script>

<style scoped>
  .icon-fa{
    color: #4fc47f;
  }
</style>
